import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/documentacion',
    name: 'Documentacion',
    component: () => import(/* webpackChunkName: "about" */ '../views/Documentacion.vue')
  },
  {
    path: '/zona/:id',
    name: 'Zona',
    component: () => import(/* webpackChunkName: "about" */ '../views/Detail.vue')
  }, 
  {
    path: '/documentacion/zona/:id',
    name: 'DocumentacionZona',
    component: () => import(/* webpackChunkName: "about" */ '../views/documentacion_zone/DocumentacionZone.vue')
  }, {
    path: '/documentacion/zona/:ruta',
    name: 'DocumentacionZonaPDF',
    component: () => import(/* webpackChunkName: "about" */ '../views/documentacion_zone/DocumentacionZone.vue')
  }, 
  {
    path: '/historico',
    name: 'Historico',
    component: () => import(/* webpackChunkName: "about" */ '../views/Historico.vue')
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
